import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarV2FilterDropdownTrigger from './VeltCommentsSidebarV2FilterDropdownTrigger/VeltCommentsSidebarV2FilterDropdownTrigger';
import VeltCommentsSidebarV2FilterDropdownContent from './VeltCommentsSidebarV2FilterDropdownContent/VeltCommentsSidebarV2FilterDropdownContent';
var VeltCommentsSidebarV2FilterDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-v2-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2FilterDropdown.Trigger = VeltCommentsSidebarV2FilterDropdownTrigger;
VeltCommentsSidebarV2FilterDropdown.Content = VeltCommentsSidebarV2FilterDropdownContent;
export default VeltCommentsSidebarV2FilterDropdown;
